import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {SystemService} from '../../services/system.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Entity, EstimationRole, ProjectGroup} from '../../pages/product/product.model';
import {ProjectTreeService} from '../project-tree/project-tree.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {EstimationListComponent} from '../estimation-list/estimation-list.component';


@Component({
    selector: 'entity-info',
    templateUrl: './entity-info.component.html',
    styleUrls: ['./entity-info.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class EntityInfoComponent implements OnInit {

    entityForm: FormGroup;
    pageType: string;

    entity: ProjectGroup;

    // @Input()
    // taskTypes: Entity[];
    //
    // @Input()
    // phaseTypes: Entity[];


    @ViewChild('estimationList')
    estimationList: EstimationListComponent;

    // @Input()
    users: Entity[];

    constructor(private _formBuilder: FormBuilder,
                public _systemService: SystemService,
                public _projectTreeService: ProjectTreeService,
                private _matSnackBar: MatSnackBar) { }

    ngOnInit(): void {
        // this.entityForm = this.createEntityForm();
        this.users = this._systemService.users;
    }

    saveEntity(): void {
        const updatedEntity: ProjectGroup = this.entityForm.getRawValue();
        updatedEntity.estimationChanged = this.entity.estimationChanged;
        updatedEntity.estimations = this.entity.estimations;

        this._projectTreeService.updateProjectGroup(updatedEntity).subscribe(
            resp => {
                this.entity = new ProjectGroup(resp);

                this._matSnackBar.open('"' + this.entity.name + '" fue guardada', 'OK', {
                    verticalPosition: 'top',
                    duration: 4000
                });
            }
        );
    }

    isTask(): boolean{
        return this.entity && (this.entity.type.type === 'GeneralTask' ||
            this.entity.type.type === 'Subcontract' ||
            this.entity.type.type === 'Request' ||
            this.entity.type.type === 'Incident');
    }

    selectEntity(selected: ProjectGroup): void{
        this.entity = selected;
        this.entityForm = this.createEntityForm();
        this.ngOnInit();
        if (this.estimationList) {
            this.estimationList.selectEntity(selected);
        }
    }




    createEntityForm(): FormGroup
    {
        return this._formBuilder.group({
            id              : [this.entity.id],
            name            : [this.entity.name],
            description     : [this.entity.description],
            type            : [this.entity.type],
            createdBy       : [this.entity.createdBy],
            inCharge        : [this.entity.inCharge],
            estimatedHH     : [this.entity.estimatedHH],
            actualHH        : [this.entity.actualHH],
            estimatedHHCost : [this.entity.estimatedHHCost],
            actualHHCost    : [this.entity.actualHHCost],
            actualCost      : [this.entity.actualCost],
            creationDate    : [this.entity.creationDate],
            start           : [this.entity.start],
            finish          : [this.entity.finish],
            difHH           : [this.entity.difHH],
            difHHCost       : [this.entity.difHHCost],
            approved        : [this.entity.approved],
            approvedBy      : [this.entity.approvedBy],
            approvedDate    : [this.entity.approvedDate]
        });
    }

}
